import { createContext } from 'react';
import ComponentOutlet from '../storyblok/ComponentOutlet';

export const LayoutContext = createContext();
function Layout({ body }) {
	return <ComponentOutlet components={body} />;
}
export default Layout;
